import { useTranslation } from 'react-i18next';
import { KoobTooltip } from '@koob/ui';
import { cva } from 'class-variance-authority';

const icon = cva(['far text-lg'], {
  variants: {
    type: {
      hotel: 'fa-bed',
      experience: 'fa-layer-group',
      template: 'fa-cube',
    },
    state: {
      pending: 'text-yellow-500',
      confirmed: 'text-green-500',
      refused: 'text-red-500',
      not_requested: 'text-gray-200',
    },
  },
});

export default function ToConnectionRequestState({
  type,
  state = 'not_requested',
  updating,
  testId,
}) {
  const { t } = useTranslation('toConnectionRequest');

  const typeTranslationKey = `typeLabels.${type}`;
  const stateTranslationKey = `stateLabels.${updating ? 'updating' : state}`;

  return (
    <div data-testid={testId}>
      <KoobTooltip
        tip={`${t(typeTranslationKey)}: ${t(stateTranslationKey)}`}
        position="bottom"
      >
        {updating ? (
          <i className="far fa-circle-notch text-gray-500 fa-spin text-lg" />
        ) : (
          <i className={icon({ type, state })} />
        )}
      </KoobTooltip>
    </div>
  );
}
